import { action, observable } from 'mobx';
import ConfigRepository from '../ConfigRepository';
import STATUS from '../../constants/Status';
import Api from '../../api';

interface IKlarnaRepositoryConfig {
  configRepository: ConfigRepository;
  api: Api;
}

class KlarnaRepository {
  @observable status = STATUS.IDLE;

  @observable configRepository: ConfigRepository;

  @observable klarnaHtmlContent: string;

  private api: Api;

  constructor(config: IKlarnaRepositoryConfig) {
    this.configRepository = config.configRepository;
    this.api = config.api;
  }

  @action
  private setStatus(status: STATUS): void {
    this.status = status;
  }

  @action
  public async loadKlarnaModalHtmlContent(): Promise<void> {
    const { klarnaContentNodeId } = this.configRepository.config;

    if (this.status === STATUS.IDLE || this.status === STATUS.ERROR) {
      try {
        this.setStatus(STATUS.LOADING);
        this.klarnaHtmlContent = await this.api.getHtmlContent(Number(klarnaContentNodeId));
        this.setStatus(STATUS.LOADED);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        this.setStatus(STATUS.ERROR);
      }
    }
  }
}

export default KlarnaRepository;
